import { useState, useEffect, useRef } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
//
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import useResponsive from '../../hooks/useResponsive';

import AppCache from '../../services/AppCache';
import URLS from '../../services/urls.service';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 46;
const APP_BAR_DESKTOP = 46;

const RootStyle = styled('div')({
    display: 'flex',
    minHeight: '100vh', // full height
    overflow: 'hidden', // stop global scroll
    background: '#fff',
});

// const MainStyle = styled('div')(({ theme }) => ({
//  flexGrow: 1,
//  overflow: 'auto',
//  minHeight: '100%',
//  paddingTop: APP_BAR_MOBILE + 4,
//    paddingBottom: theme.spacing(1),
//    transition: 'margin-left 0.2s ease-in-out',
//  [theme.breakpoints.up('lg')]: {
//    paddingTop: APP_BAR_DESKTOP + 4,
//   /* paddingLeft: theme.spacing(2), */
//      // paddingRight: theme.spacing(2)
//  }
// }));

const MainStyle = styled('div')(({ theme }) => ({
    flexGrow: 1,
    height: `calc(100vh - ${APP_BAR_MOBILE}px)`,  // subtract header height
    overflowY: 'auto',
    marginTop: APP_BAR_MOBILE,   // 👈 pushes content below navbar
    transition: 'margin-left 0.2s ease-in-out',
    [theme.breakpoints.up('lg')]: {
        height: `calc(100vh - ${APP_BAR_DESKTOP}px)`,
        marginTop: APP_BAR_DESKTOP, // 👈 for desktop
    },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {

    console.log("click>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
    const [open, setOpen] = useState(false);
    const [openSidebar, setOpenSidebar] = useState(false);
    const isDesktop = useResponsive('up', 'md');
    const [width, setWidth] = useState(240);
    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;
    const prevPathRef = useRef('');
    const [currentPath, setCurrentPath] = useState(location.pathname);
    const [acknowledgeData, setAcknowledgeData] = useState([]);

    const onCloseSidebar = () => {
        setOpen(true);
        setOpenSidebar(true);
        setWidth(240);
        console.log(">>>>>>>>>>>>>>>>")
    };

    const onOpenSidebar = () => {
        setOpen(false);
        setOpenSidebar(false);
        setWidth(0);
        console.log("++++++++++++")

    };
    const onCollapseSidebar = () => {
        setOpen(false); // Set to false when collapsing
        setOpenSidebar(false);
        setWidth(0); // Set the width to 0 when collapsed
    };
    const handleChildItemClick = (MenuURL) => {
        console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~", MenuURL);

        if (typeof MenuURL === "string" && MenuURL.includes("|")) {
            sessionStorage.setItem("menuUrl", MenuURL);

            const [url, id] = MenuURL.split("|");   // split raw menuUrl
            console.log("url:", url, "id:", id);

            // navigate with trackerId in query string
            navigate(`/dashboard/${url}?trackerId=${id}`, { state: { menuUrl: MenuURL } });

            onCollapseSidebar();
        } else {
            console.log("Invalid MenuURL:", MenuURL);
        }
    };
    const loadIssueAcknowledgement = () => {
        const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
        const userId = CurrentLoggedInUser?.ExecutiveId;

        if (!userId) return;

        URLS.loadIssueAcknowledgement({ LoginUserId: userId })
            .then((response) => {

                const data = Array.isArray(response.data) ? response.data : [];
                setAcknowledgeData(data);

            })
            .catch(() => {
                console.log("Error loading priority");
            });
    };

    useEffect(() => {
        if (!isDesktop) {
            setOpen(false);
            setOpenSidebar(false);
            setWidth(0);
        }
    }, [isDesktop]);

    useEffect(() => {
        if (open) {
            onCollapseSidebar(); // Collapse the sidebar for other pathname changes
        }
    }, [pathname]);

    // Update previous and current paths
    useEffect(() => {
        prevPathRef.current = currentPath;
        setCurrentPath(location.pathname);
    }, [location.pathname]);

    useEffect(() => {
        loadIssueAcknowledgement();

        const handleAnyEvent = () => {
            loadIssueAcknowledgement();
        };

        window.addEventListener("click", handleAnyEvent);
        window.addEventListener("change", handleAnyEvent);
        window.addEventListener("submit", handleAnyEvent);
        window.addEventListener("acknowledgementUpdated", handleAnyEvent);
        return () => {
            window.removeEventListener("click", handleAnyEvent);
            window.removeEventListener("change", handleAnyEvent);
            window.removeEventListener("submit", handleAnyEvent);
            window.addEventListener("acknowledgementUpdated", handleAnyEvent);
        };

    }, []);

    console.log("previousPath", prevPathRef.current, prevPathRef, "currentPath", currentPath, "acknowledgeData", acknowledgeData);

    return (
        <RootStyle>
            {/* <DashboardNavbar onOpenSidebar={() => setOpen(true)} /> */}
            {/* <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} /> */}

            <DashboardNavbar dwidth={width} openNav={open} onOpenSidebar={onCloseSidebar} acknowledgeData={acknowledgeData} />
            < DashboardSidebar isOpenSidebar={open} onCloseSidebar={onCloseSidebar} dwidth={width} onOpenSidebar={onOpenSidebar} handleChildItemClick={handleChildItemClick} />

            <MainStyle dwidth={open ? width : 0}>
                <Outlet context={{
                    onCloseSidebar, onOpenSidebar, open, previousPath: prevPathRef.current,
                    currentPath, acknowledgeData, openSidebar
                }} />

            </MainStyle>

        </RootStyle>
    );
}
